import React from 'react';
import PropTypes from 'prop-types';
// import { Link } from 'react-router-dom';
import { SectionTypes } from '../types/entities';
import { CardHeader } from './Card';
import { FormGroup } from './Forms';
import RevertableForm from './RevertableForm';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faUnlink } from '@fortawesome/fontawesome-free-solid';
import { faTrashAlt } from '@fortawesome/fontawesome-free-regular';

class SectionForm extends RevertableForm {
  constructor(props) {
    super(props);
    this.state = { addToSong: true };
  }

  defaultNewObj = {
    label: '',
    type: '',
  };

  render() {
    const values = (this.state.id ? this.props.obj : this.state.newObj) || {};
    const { props } = this;
    return (
      <form className="card mb-3" style={{ border: 'none' }}>
        <div className="card-body">
          <CardHeader
            title={
              this.props.obj ? `${values.label || values.type || 'Section'}` : 'Create section'
            }
          />

          {/*
          <FormGroup
            label="Type"
            control="select"
            name="type"
            customForms
            value={values.type}
            onChange={this.handleChange}
            choices={[['', '- Other -'], ...SectionTypes.map(t => [t, t])]}
          />
          */}

          <FormGroup
            label="Type"
            type="radio"
            name="type"
            customForms
            value={values.type || ''}
            onChange={this.handleChange}
            choices={SectionTypes.map(t => [t, t])}
            inline
          >
            <option value="">- Other -</option>
            {SectionTypes.map(t => (
              <option key={t} value={t}>
                {t}
              </option>
            ))}
          </FormGroup>

          <FormGroup
            label="Label"
            name="label"
            value={(values || {}).label || ''}
            onChange={this.handleChange}
            datalist={SectionTypes}
            placeholder={values.type || ''}
            help="Eg. Verse 1, Breakdown, Tag, etc."
          />

          {!this.state.id && (
            <div>
              <div className="form-group">
                <label htmlFor="sectionLyricsTextarea">Lyrics</label>
                <textarea
                  id="sectionLyricsTextarea"
                  name="lyrics"
                  className="form-control"
                  placeholder=""
                  rows={this.props.rows}
                  value={values.lyrics || ''}
                  onChange={this.handleChange}
                />
                <small id="sectionLabelInput" className="form-text text-muted">
                  Leave blank to add later or use existing lines.
                </small>
              </div>
              <div className="form-group form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="sectionAddToSongCheckbox"
                  name="addToSong"
                  onChange={this.handleChange}
                  checked={this.state.addToSong}
                />
                <label className="form-check-label" htmlFor="sectionAddToSongCheckbox">
                  Add to song
                </label>
              </div>
            </div>
          )}
        </div>
        <div className="card-footer d-flex w-100 justify-content-between bg-white">
          <div className="dropdown">
            <a
              className="card-link dropdown-toggle text-danger"
              title="Delete / Remove"
              href="#delete-remove"
              role="button"
              id="dropdownMenuLink"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <FontAwesomeIcon icon={faTrashAlt} />
            </a>
            <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
              {props.section && props.sectionIndex >= 0 ? (
                <a
                  className="dropdown-item pl-3"
                  href="#remove-line"
                  onClick={e => props.onRemove(e, props.sectionIndex)}
                >
                  <FontAwesomeIcon icon={faUnlink} className=" mr-3" />Remove from song structure
                </a>
              ) : (
                <span className="dropdown-item pl-3">
                  <FontAwesomeIcon icon={faUnlink} className=" mr-3" />Remove from song structure
                </span>
              )}
              <div className="dropdown-divider" />
              <a
                className="dropdown-item text-danger pl-3"
                href="#delete-line"
                onClick={e => props.onDelete(e, props.section.id)}
              >
                <FontAwesomeIcon icon={faTrashAlt} className=" mr-3" />Delete
              </a>
            </div>
          </div>
          {this.getRevertButton()}
          {this.getCreateButton()}
        </div>
      </form>
    );
  }
}

SectionForm.defaultProps = {
  section: undefined,
  onSubmit: undefined,
  rows: 4,
  submitText: 'Save',
};
SectionForm.propTypes = {
  section: PropTypes.shape({
    id: PropTypes.number,
    label: PropTypes.string,
    lines: PropTypes.arrayOf(PropTypes.number),
    type: PropTypes.oneOf(SectionTypes),
  }),
  onSubmit: PropTypes.func,
  rows: PropTypes.number,
  submitText: PropTypes.string,
};

export default SectionForm;



// WEBPACK FOOTER //
// ./src/components/SectionForm.js